import { style } from "typestyle";

export const organization = style({
  marginBottom: "2rem"
});

export const organizationName = style({
  marginBottom: "1rem"
});
